import React from 'react'
import { observer } from 'mobx-react-lite'
import useCareerQuizSubmission from './hooks/useCareerQuizSubmission'
import s from './styles/CareerQuizSubmission.module.scss'
import sharedStyles from '../shared/submissionStyles.module.scss'

const CareerQuizSubmission = observer(({ assignment, student }) => {
	const { careers, isLoading, personalityType, isLoadingPersonality, responseText, hasResponse } =
		useCareerQuizSubmission({
			assignment,
			student,
		})

	return (
		<div className={s.container}>
			<div className={sharedStyles.submission}>
				<div className={sharedStyles.submission__inner}>
					<span className={sharedStyles.title}>SUBMISSION</span>

					<div className={sharedStyles.sectionsRow}>
						{/* Personality found section */}
						<div className={`${sharedStyles.section} ${sharedStyles.short}`}>
							<span className={sharedStyles.section__title}>
								Personality found
							</span>
							<div className={sharedStyles.personalityBadgeContainer}>
								{isLoadingPersonality ? (
									<div className={sharedStyles.loading}>Loading...</div>
								) : personalityType?.name ? (
									<span className={sharedStyles.pill}>
										{personalityType.name}
									</span>
								) : (
									<div className={sharedStyles.empty}>
										No personality type found
									</div>
								)}
							</div>
						</div>

						{/* Career Shortlisted section */}
						<div className={sharedStyles.section}>
							<span className={sharedStyles.section__title}>
								Career Shortlisted
							</span>
							<div className={sharedStyles.badgesList}>
								{isLoading ? (
									<div className={sharedStyles.loading}>Loading careers...</div>
								) : careers && careers.length > 0 ? (
									careers.map((career, index) => {
										const careerName =
											typeof career === 'string'
												? career
												: career?.name || career?.title || 'Unknown Career'
										return (
											<span
												key={`career-${index}-${careerName}`}
												className={sharedStyles.badge}
											>
												{careerName}
											</span>
										)
									})
								) : (
									<div className={sharedStyles.empty}>
										No careers have been shortlisted yet
									</div>
								)}
							</div>
						</div>
					</div>

					<div className={sharedStyles.section}>
						<span className={sharedStyles.section__title}>
							Student's Response
						</span>
						<div className={sharedStyles.textArea}>
							{hasResponse ? (
								<p className={sharedStyles.textContent}>{responseText}</p>
							) : (
								<div className={sharedStyles.empty}>
									No response submitted yet
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
})

CareerQuizSubmission.displayName = 'CareerQuizSubmission'

export default CareerQuizSubmission
